// github.js — Populates the nav GitHub summary and 14-day contribution heatmap.

function ordinalDay(n) {
  if (n >= 11 && n <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
}

// Single tooltip element appended to <body> so it's never clipped by nav overflow.
function getTooltip() {
  let el = document.getElementById('commit-tooltip');
  if (!el) {
    el = document.createElement('div');
    el.id = 'commit-tooltip';
    document.body.appendChild(el);
  }
  return el;
}

function formatSummary(contributionTotal) {
  return Number.isFinite(contributionTotal)
    ? contributionTotal.toLocaleString('en-US')
    : '--';
}

export async function initGithub() {
  // Build 14-day key list, oldest first (day 14 → day 1 = yesterday)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dayKeys = [];
  for (let i = 14; i >= 1; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    dayKeys.push(d.toISOString().slice(0, 10));
  }

  const dayMap = Object.fromEntries(dayKeys.map(k => [k, 0]));
  let contributionTotal = null;

  try {
    const res = await fetch('/.netlify/functions/github');
    if (res.ok) {
      const data = await res.json();
      const { days = {}, yearContributionTotal } = data;
      for (const key of dayKeys) {
        if (key in days) dayMap[key] = days[key];
      }
      contributionTotal = Number.isFinite(yearContributionTotal)
        ? yearContributionTotal
        : null;
    }
  } catch (_) {
    // Running without netlify dev — squares stay empty, that's fine
  }

  const summary = formatSummary(contributionTotal);
  const contributionEl = document.getElementById('github-year-count');
  if (contributionEl) contributionEl.textContent = summary;

  // ── Render commit squares ─────────────────────────────
  const tooltip = getTooltip();
  let total = 0;
  const boxes = document.querySelectorAll('.commit-day');

  boxes.forEach((box, i) => {
    const key   = dayKeys[i];
    const count = dayMap[key] ?? 0;
    total += count;

    const level = count === 0 ? 0
                : count <= 2  ? 1
                : count <= 5  ? 2
                : 3;
    box.dataset.level = level;

    const d     = new Date(key + 'T12:00:00');
    const month = d.toLocaleDateString('en-US', { month: 'long' });
    const day   = ordinalDay(d.getDate());
    const tip   = count === 0
      ? `No contributions on ${month} ${day}.`
      : count === 1
        ? `1 contribution on ${month} ${day}.`
        : `${count} contributions on ${month} ${day}.`;

    box.addEventListener('mouseenter', (e) => {
      tooltip.textContent = tip;
      tooltip.classList.add('visible');
      tooltip.style.left = `${e.clientX}px`;
      tooltip.style.top  = `${e.clientY + 20}px`;
    });
    box.addEventListener('mousemove', (e) => {
      tooltip.style.left = `${e.clientX}px`;
      tooltip.style.top  = `${e.clientY + 20}px`;
    });
    box.addEventListener('mouseleave', () => {
      tooltip.classList.remove('visible');
    });
  });

  // ── Render 14-day total ───────────────────────────────
  const countEl = document.getElementById('commit-count');
  if (countEl) countEl.textContent = total;
}
